
import { DateTime } from 'luxon';


class LuckyNumbersService {

  private apiUrlHost: string = `https://api.kofc1056.org/api`;
  //private apiUrlHost: string = `http://localhost:3002`;

  public async purchase(data: any): Promise<any> {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    };

    const res = await fetch(`${this.apiUrlHost}/luckynumbers/purchase`, requestOptions);
    console.log("Response", res);
    const purchResponse: any = await res?.json();

    return purchResponse;
  }

  public async getLuckyNumbers(): Promise<any> {

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    };

    const res = await fetch(`${this.apiUrlHost}/luckynumbers`, requestOptions);
    console.log("Response", res);
    const luckyNumbersResponse: any = await res?.json();

    return luckyNumbersResponse;
  }

}

export default LuckyNumbersService;